import { useAppStore } from "../../store";
export var initTabEvent = function initTabEvent() {
  var add = function add(path, options) {
    setTimeout(function () {
      window.microApp.dispatch({
        tabsHandler: "add",
        tabsHandlerOptions: {
          path: path,
          options: options
        }
      });
    }, 0);
  };
  var remove = function remove(path, options) {
    setTimeout(function () {
      window.microApp.dispatch({
        tabsHandler: "remove",
        tabsHandlerOptions: {
          path: path,
          options: options
        }
      });
    }, 0);
  };
  var closeAll = function closeAll() {
    setTimeout(function () {
      window.microApp.dispatch({
        tabsHandler: "closeAll"
      });
    }, 0);
  };
  var back = function back() {
    setTimeout(function () {
      window.microApp.dispatch({
        tabsHandler: "back"
      });
    }, 0);
  };
  useAppStore.getState().setPageHandlers({
    add: add,
    remove: remove,
    closeAll: closeAll,
    back: back
  });
};